import { useGeneralGetHook } from "api/hooks/allHooks";
import { customApiCall } from "utils/axios";

import type { CreateJobResponse, JobPollResponse, SingleBuildingFormState } from "../model/types";

import { convertFormDataToPayload, convertFormDataToUpdatePayload } from "../lib/formDataToPayload";
import addBuildingUrls from "./urls";

export const pollJobStatus = (jobId: string): Promise<JobPollResponse> => {
  const url = addBuildingUrls.jobStatus(jobId);
  return customApiCall.get({ url });
};

export const submitNewBuilding = async (
  formData: SingleBuildingFormState,
  dtCreation: boolean
): Promise<CreateJobResponse | undefined> => {
  if (!formData) return;
  const payload = convertFormDataToPayload(formData, dtCreation);
  if (!payload) return;
  const response = await customApiCall.post({ data: payload, url: addBuildingUrls.create() });
  return response;
};

export const updateExistingBuiding = async (
  formData: SingleBuildingFormState,
  dtCreation: boolean,
  projectId: string | undefined,
  isEpcExtractionAvailable: boolean
) => {
  if (!projectId) return;
  const updatePayload = convertFormDataToUpdatePayload(formData, projectId, dtCreation, isEpcExtractionAvailable);
  if (!updatePayload) return;
  const response = await customApiCall.post({ data: updatePayload, url: addBuildingUrls.updateBuilding() });
  return response;
};

export const useGetBuildingJobInfo = (
  projectId: string | undefined,
  enabled = false,
  refetchInterval?: boolean | number
) => {
  const url = addBuildingUrls.buildingJobInfo(projectId);
  return useGeneralGetHook(["buildingJobInfo", projectId], url, { enabled, refetchInterval }) as {
    data: JobPollResponse;
    isLoading: boolean;
  };
};
